
import MoviePosterRow from "components/program/MoviePosterRow";
import { sortCurrentMoviesProgramByFirstShow } from "lib/client/movieinfo";
import { ICurrentMoviesProgram } from "lib/types/Program";
import { ICommonAppData } from "lib/types/sanity";
import dynamic from "next/dynamic";
import { useMemo } from "react";
import styled from "styled-components";

const DynamicAdnuntiusAd = dynamic(() =>
	import('components/framework/AdnuntiusAd').then((mod) => mod.default),
	{ ssr: false }
);


//#region [Styles]
const SRowContainer = styled.div`
	display: flex;
	flex-direction: column;
	@media screen and (max-width: 640px) {
		div:first-child ~ article {
			order: 3;
		}

		div:first-child ~ article:nth-child(2) {
			order: 0;
		}
		div:first-child ~ article:nth-child(3) {
			order: 1;
		}
	}

`;

const SAd = styled(DynamicAdnuntiusAd)`
	order: 2;
	margin-bottom: 40px;
`;
//#endregion

//#region [Props]
type PostersViewProps = {
	data: ICurrentMoviesProgram;
	allowTitleOverride?: boolean;
	appData: ICommonAppData;
};
//#endregion

//#region [Component]
export default function PostersView({ appData, data, allowTitleOverride }: PostersViewProps) {
	const orderedData = useMemo(() => {
		if ((data?.movies?.length ?? 0) === 0) {
			return null;
		}
		return sortCurrentMoviesProgramByFirstShow(data);

	}, [data]);

	if ((orderedData?.movies?.length ?? 0) === 0) {
		return null;
	}
	return (<SRowContainer>
		<SAd appData={appData} index={0} hideOnMobile={false} hideOnDesktop={true} /> {/** Top ad */}
		{orderedData!.movies.map(movie => <MoviePosterRow key={movie.mainVersionId} movie={movie} filmwebMovie={data.filmwebMovies?.[movie.mainVersionId]} allowTitleOverride={allowTitleOverride} localMovie={data.fwpakkeArticles?.[movie.mainVersionId]} />)}
	</SRowContainer>);
}
//#endregion
